import { useContext } from 'react'
import { LocaleContext } from '../contexts/localeContext'

const useLocale = () => {
  return useContext(LocaleContext)
}

export default useLocale
